// extracted by mini-css-extract-plugin
export default {"containerRes":"ResultFala_containerRes__Ro4Lu","certo":"ResultFala_certo__Ocl65","errado":"ResultFala_errado__mCmwK"};